import { server_connection } from 'config';
import moment from 'moment'
import { getScheduledCourses } from './company.actions';
import { getCompanyData } from './company.actions';

export const GET_COURSE_LESSONS = '[COMPANY APP] GET COURSE LESSONS';
export const ADD_COURSE_TO_SCHEDULE = '[COMPANY APP] ADD COURSE TO SCHEDULE';
export const ADD_MODULE_TO_SCHEDULE = '[COMPANY APP] ADD MODULE TO SCHEDULE';
export const MOVE_LESSON = '[COMPANY APP] MOVE LESSON';
export const GET_COURSE_PREVIEW = '[COMPANY APP] GET COURSE PREVIEW';
export const GET_MODULE_PREVIEW = '[COMPANY APP] GET MODULE PREVIEW';
export const GET_SAVED_EVENTS = '[COMPANY APP] GET EVENTS';
export const GET_DAY_EVENTS = '[COMPANY APP] GET DAY EVENTS';
export const CHECK_LESSON_OVERWRITE = '[COMPANY APP] CHECK LESSON OVERWRITE';
export const HANDLE_EVENT_SELECT = '[COMPANY APP] HANDLE EVENT SELECT';
export const TOGGLE_UNSCHEDULED_ADD_DIALOG = '[COMPANY APP] TOGGLE UNSCHEDULED ADD DIALOG';
export const GET_UNSCHEDULED_COURSES = '[COMPANY APP] GET UNSCHEDULED COURSES';

export function getCourseLessons(course_id, company_id, startDate) {
    return (dispatch) => {
        return fetch(server_connection + '/course/schedule/' + course_id)
            .then((response) => response.json())
            .then((lessons) => {
                dispatch(addCourseToSchedule(course_id, company_id, startDate, lessons))
            })
    }
}

export function getCalendarData(company_id, start) {
    return (dispatch) => {
        Promise.all([
            dispatch(getEvents(company_id, start)),
            dispatch(getScheduledCourses(company_id, start))
        ])
    }
}

export function addCourseToSchedule(course_id, company_id, startDate) {
    return (dispatch) => {
        fetch(server_connection + '/company/schedule/course',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ course_id: course_id, company_id: company_id, startDate: startDate })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getCalendarData(company_id, startDate)
                );
            });
    }
}

export function addModuleToSchedule(module_id, company_id, startDate, company_course_id) {
    return (dispatch) => {
        fetch(server_connection + '/company/schedule/module',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ module_id: module_id, company_id: company_id, startDate: startDate, company_course_id: company_course_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getEvents(company_id, startDate));
            });
    }
}

export function addLessonToSchedule(lesson_id, company_id, startDate, company_course_id) {
    return (dispatch) => {
        fetch(server_connection + '/company/schedule/lesson',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ lesson_id: lesson_id, company_id: company_id, startDate: startDate, company_course_id: company_course_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getEvents(company_id, startDate));
            });
    }
}

export function moveLesson(event, start, company_id, breakBool) {
    return (dispatch) => {
        fetch(server_connection + '/company/schedule/move_lesson',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ event: event, start: start, company_id: company_id, breakBool: breakBool })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getEvents(company_id, start));
            });
    }
}

export function overwriteLesson(company_id, actionType, newLesson, oldLesson) {
    return (dispatch) => {
        fetch(server_connection + '/company/schedule/overwrite_lesson',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    company_id: company_id,
                    actionType: actionType,
                    newLesson: newLesson,
                    oldLesson: oldLesson,
                })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getEvents(company_id, newLesson.start));
            });
    }
}

export function checkLessonOverwrite(newEvent, oldEvent, date) {
    return {
        type: CHECK_LESSON_OVERWRITE,
        payload: { newEvent: newEvent, oldEvent: oldEvent, date: date }
    }
}


export function getCoursePreview(course_id) {
    return (dispatch) => {
        return fetch(server_connection + '/course/schedule/' + course_id)
            .then((response) => response.json())
            .then((lessons) => {
                dispatch({
                    type: GET_COURSE_PREVIEW,
                    payload: { lessons: lessons, course_id: course_id }
                })
            })
    }
}

export function getModulePreview(module_id) {
    return (dispatch) => {
        return fetch(server_connection + '/module/get_lessons/' + module_id)
            .then((response) => response.json())
            .then((lessons) => {
                dispatch({
                    type: GET_MODULE_PREVIEW,
                    payload: {
                        module_id: module_id,
                        lessons: lessons
                    }
                })
            })
    }
}

export function getEvents(company_id, chooseDate) {
    return async (dispatch) => {
        return await fetch(server_connection + '/company/schedule/' + company_id + '/' + chooseDate)
            .then((response) => response.json())
            .then((lessons) => {
                dispatch({
                    type: GET_SAVED_EVENTS,
                    payload: lessons
                })
            })
    }
}

export function getDayEvents(company_id, date) {
    return async (dispatch) => {
        return await fetch(server_connection + '/company/day/' + company_id + '/' + date)
            .then((response) => response.json())
            .then((events) => {
                dispatch({
                    type: GET_DAY_EVENTS,
                    payload: events
                })
            })
    }
}

export function handleEventSelect(lesson_id, module_id, course_id) {
    return {
        type: HANDLE_EVENT_SELECT,
        payload: { lesson_id: lesson_id, module_id: module_id, course_id: course_id }
    }
}

export function deleteCourseFromSchedule(company_id, company_calendar_course_id, event, unscheduled) {
    return (dispatch, getState) => {
        fetch(server_connection + '/company/schedule/delete/course',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ company_calendar_course_id: company_calendar_course_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                if (unscheduled) {
                    dispatch(getUnscheduledCourses(company_id));
                }
                else {
                    dispatch(getCalendarData(company_id, event.start));
                }
            });
    }
}

export function deleteModuleFromSchedule(company_id, company_calendar_module_id, event) {
    return (dispatch, getState) => {
        fetch(server_connection + '/company/schedule/delete/module',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ company_id: company_id, company_calendar_module_id: company_calendar_module_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getEvents(company_id, event.start));
            });
    }
}

export function deleteLessonFromSchedule(company_id, company_calendar_day_id, event) {
    return (dispatch, getState) => {
        fetch(server_connection + '/company/schedule/delete/lesson',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ company_id: company_id, company_calendar_day_id: company_calendar_day_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getEvents(company_id, event.start));
            });
    }
}

export function deleteDayEvent(event_id, company_id, eventDate) {
    return (dispatch, getState) => {
        fetch(server_connection + '/company/schedule/delete/day_event',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ event_id: event_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getDayEvents(company_id, moment(eventDate).format('YYYY-MM-DD')));
            });
    }
}

export function resizeDayEvent(event, company_id) {
    return (dispatch) => {
        fetch(server_connection + '/company/schedule/resize_day_event',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ event: event })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getDayEvents(company_id, moment(new Date(event.start)).format('YYYY-MM-DD')));
            });
    }
}

export function toggleUnscheduledAddDialog(setting) {
    return {
        type: TOGGLE_UNSCHEDULED_ADD_DIALOG,
        payload: setting
    }
}

export function confirmUnscheduledCourse(course, company_id) {
    return (dispatch) => {
        fetch(server_connection + '/company/unscheduled/course/confirm',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ course, company_id })
            })
        .then((response) => response.json())
        .then((responseData) => {
            dispatch(getUnscheduledCourses(company_id));
        });
    }
}

export function getUnscheduledCourses(company_id) {
    return async (dispatch) => {
        return await fetch(server_connection + '/company/unscheduled_courses/' + company_id)
            .then((response) => response.json())
            .then((courses) => {
                dispatch({
                    type: GET_UNSCHEDULED_COURSES,
                    payload: courses
                })
            })
    }
}

// export function addLessonToCourse(event, company_id, startDate, company_course_id) {
//     return (dispatch) => {
//         fetch(server_connection + '/company/add_lesson_to_course/',
//             {
//                 headers: {
//                     'Accept': 'application/json, text/plain, */*',
//                     'Content-Type': 'application/json'
//                 },
//                 method: 'POST',
//                 body: JSON.stringify({ event: event, company_id: company_id, startDate: startDate, company_course_id: company_course_id })
//             })
//             .then((response) => response.json())
//             .then((responseData) => {
//                 dispatch(getEvents(company_id, event.start.getMonth(), event.start.getFullYear()));
//             });
//     }
// }



// WEBPACK FOOTER //
// src/main/content/company/store/actions/calendar.actions.js